import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { v4 as uuidv4 } from 'uuid'
import {
  AdjustIcon,
  SpinWrapper,
} from 'modules/Onboarding/Register/Education/style'
import ProjectForm from 'modules/Onboarding/Register/ProjectInternshipNew/Project'
import {
  ButtonLocal,
  Text,
} from 'modules/Onboarding/Register/ProjectInternship/style'
import { SubHeading1 } from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import moment from 'moment'

const ProjectInternship = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  getListOfSkills,
  activeKey,
  cvDetails,
  getCorporateList,
  searchAPI,
  getDesignationsList,
  getFunctionsList,
  getIndustryList,
  setActiveTab,
  getStudentData,
  registerForm,
  pendingData,
}) => {
  const [form] = Form.useForm()
  const formRef = useRef()
  
  // Register this form with the parent component for stepper validation
  useEffect(() => {
    if (typeof registerForm === 'function') {
      // Create an enhanced form that directly calls submitHandler
      const enhancedForm = {
        ...form,
        submit: () => {
          // Call the submitHandler directly when submit is triggered from stepper
          submitHandler();
          return Promise.resolve();
        }
      };
      
      registerForm('project', enhancedForm);
      
      // Cleanup when component unmounts
      return () => registerForm('project', null);
    }
  }, [form, registerForm])
  const [project, setProject] = useState([])
  const [internship, setInternship] = useState([])
  const [projectUpdated, setProjectUpdated] = useState([])
  const [internshipUpdated, setInternshipUpdated] = useState([])
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [skillLoading, setSkillLoading] = useState(true)
  const [loading, setLoading] = useState(true)
  const [allSkills, setAllSkills] = useState([])
  const [isCvTrue, setIsCvTrue] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [shown, setShown] = useState([])
  const [updated, setUpdated] = useState(false)
   const [listOfAddedSkills,setListOfAddedSkills]=useState([])

  const SkillsAPI = async search => {
    try {
      const results = await searchAPI( searchConfig?.skills?.name, search, searchConfig?.skills )
      let updatedSkills = results || [];
      const newSkill = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      };
    if (updatedSkills.length === 0 && search) {
      setListOfAddedSkills(prev => [...prev, newSkill]);
      updatedSkills = [newSkill, ...updatedSkills];
    }
      const isExactMatch = updatedSkills.some(skill => skill?.name.toLowerCase() === search?.toLowerCase());
      if(updatedSkills.length > 0 ){
        if(!isExactMatch && search?.length > 3){ 
          setListOfAddedSkills(prev => [...prev, newSkill]);
          updatedSkills = [newSkill, ...updatedSkills];
        } else {
          updatedSkills = updatedSkills
        }
      }

      if (!allSkills?.length) {
        setAllSkills(updatedSkills)
      }
      setSkillLoading(false)
      return updatedSkills
    } catch (error) {
      setSkillLoading(false)

      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }
  useLayoutEffect(() => {
    SkillsAPI()
  }, [])

  const updateProjectDetails = async studentProjectDetails => {
    let projectList = []
    studentProjectDetails?.map((data, index) => {
      let formName = 'project_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          corporateId: data?.corporateId,
          organization: data?.organization,
          title: data?.title,
          started_in: moment(data?.started_in, 'MM/YYYY').isValid() ? data?.started_in : null ,
          ended_in: moment(data?.ended_in, 'MM/YYYY').isValid() ? data?.ended_in : null,
          function: data?.function,
          role: data?.role,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate && (data?.certificate?.size || data?.certificate?.url) ? data?.certificate : null,
          awards: data?.awards,
          isDelete: false,
        },
      })
      return projectList.push({
        component: ProjectForm,
        formName: formName,
      })
    })
    setProjectUpdated(projectList)
    setProject(projectList)
  }

  const updateInternshipDetails = studentInternshipDetails => {
    let internshipList = []
    studentInternshipDetails?.map((data, index) => {
      let formName = 'internship_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          title: data?.title,
          corporateId: data?.corporateId,
          organization: data?.organization,
          started_in: moment(data?.started_in, 'MM/YYYY').isValid() ? data?.started_in : null,
          ended_in: moment(data?.ended_in, 'MM/YYYY').isValid() ? data?.ended_in : null,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate && (data?.certificate?.size || data?.certificate?.url) ? data?.certificate : null,
          function: data?.function,
          role: data?.role,
          awards: data?.awards,
          isDelete: false,
        },
      })
      return internshipList.push({
        component: ProjectForm,
        formName: formName,
      })
    })
    setInternshipUpdated(internshipList)
    setInternship(internshipList)
  }

  useEffect(() => {
    const pendingProjects = pendingData?.resume?.projects || []
    const pendingInternships = pendingData?.resume?.internships || []
    
    // Only use CV data if there's no actual data AND no pending data
    let studentProjectDetails = studentFormData?.resume?.projects?.length
      ? studentFormData?.resume?.projects
      : (pendingProjects?.length ? [] : cvDetails?.projects || [])

    let studentInternshipDetails = studentFormData?.resume?.internships?.length
      ? studentFormData?.resume?.internships
      : (pendingInternships?.length ? [] : cvDetails?.internships || [])
    
    // Use pendingMap pattern for projects
    if (pendingProjects.length > 0) {
      const pendingMap = new Map()
      pendingProjects.forEach(p => {
        if (p.id && !p.id.startsWith('temp-')) {
          pendingMap.set(p.id, p)
        }
      })
      
      studentProjectDetails = studentProjectDetails.map(approvedProj => {
        const pendingProj = pendingMap.get(approvedProj.id)
        
        if (pendingProj && pendingProj._pendingFields) {
          const merged = { ...approvedProj }
          
          Object.keys(pendingProj._pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingProj._pendingFields[fieldName].value
          })
          
          merged._hasPendingChanges = true
          merged._pendingFields = pendingProj._pendingFields
          
          return merged
        }
        
        return approvedProj
      })
      
      const newPendingProjects = pendingProjects.filter(
        p => !p.id || p.id.startsWith('temp-') || p._isNew
      )
      studentProjectDetails = [...studentProjectDetails, ...newPendingProjects]
    }
    
    // Use pendingMap pattern for internships
    if (pendingInternships.length > 0) {
      const pendingMap = new Map()
      pendingInternships.forEach(p => {
        if (p.id && !p.id.startsWith('temp-')) {
          pendingMap.set(p.id, p)
        }
      })
      
      studentInternshipDetails = studentInternshipDetails.map(approvedIntern => {
        const pendingIntern = pendingMap.get(approvedIntern.id)
        
        if (pendingIntern && pendingIntern._pendingFields) {
          const merged = { ...approvedIntern }
          
          Object.keys(pendingIntern._pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingIntern._pendingFields[fieldName].value
          })
          
          merged._hasPendingChanges = true
          merged._pendingFields = pendingIntern._pendingFields
          
          return merged
        }
        
        return approvedIntern
      })
      
      const newPendingInternships = pendingInternships.filter(
        p => !p.id || p.id.startsWith('temp-') || p._isNew
      )
      studentInternshipDetails = [...studentInternshipDetails, ...newPendingInternships]
    }

    if (
      (studentFormData?.resume?.projects?.length <
        cvDetails?.projects?.length ||
        studentFormData?.resume?.internships?.length <
          cvDetails?.internships?.length) &&
      !isCvTrue
    ) {
      setIsCvTrue(true)
    }
    updateProjectDetails(studentProjectDetails)
    updateInternshipDetails(studentInternshipDetails)
    
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [studentFormData, cvDetails, pendingData])

  useEffect(() => {
    let studentProjectDetails = studentFormData?.resume?.projects?.length
      ? studentFormData?.resume?.projects
      : cvDetails?.projects || []

    let studentInternshipDetails = studentFormData?.resume?.internships?.length
      ? studentFormData?.resume?.internships
      : cvDetails?.internships || []

    if (
      loading &&
      project?.length == studentProjectDetails?.length &&
      internship?.length == studentInternshipDetails?.length
    ) {
      setLoading(false)
    }
  }, [project, internship])

  const projectHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = form.getFieldValue()
    const projects = {}
    const internships = {}
    for (const key in experienceKeys) {
      if (key.startsWith('project_')) {
        projects[key] = experienceKeys[key]
      } else if (key.startsWith('internship_')) {
        internships[key] = experienceKeys[key]
      }
    }

    const projectKeys = Object.keys(projects)
    let lastValue = 0
    for (let i = projectKeys.length - 1; i >= 0; i--) {
      const key1 = projectKeys[i]
      const intValue = parseInt(key1.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }

    let arr = []
    let formName = 'project_' + (lastValue + 1)

    if (isAdd) {
      arr.push({ component: ProjectForm, formName: formName })
      setProject(proj => proj.concat(arr))
      setProjectUpdated(proj => proj.concat(arr))
    }
  //   if (isDelete) {
  //     form.setFieldValue([[deleteForm], 'isDelete'], true)
  //     if (form.getFieldValue([deleteForm, 'isDelete']) === true) {
  //       form.resetFields([deleteForm])
  //     }

  //     let formDatas = form.getFieldValue()
  //     let updatedListData = []
  //     project.map((data, index) => {
  //       let newFormName = 'project_' + index
  //       if (deleteForm !== newFormName) {
  //         Object.entries(formDatas).map(([name, item]) => {
  //           let currentFormValue = item
  //           if (name.includes(data?.formName)) {
  //             form.setFieldsValue({
  //               [name]: null,
  //               'skill_set': [],
  //             })
  //             if (name?.includes('award')) {
  //               let awardIndex = name?.split('_')[3]

  //               let newAwardName = newFormName + '_award_' + awardIndex
  //               form.setFieldsValue({
  //                 [newAwardName]: {
  //                   ...currentFormValue,
  //                 },
  //               })
  //             } else {
  //               form.setFieldsValue({
  //                 [newFormName]: {
  //                   ...currentFormValue,
  //                 },
  //               })
  //               updatedListData.push({
  //                 component: ProjectForm,
  //                 formName: newFormName,
  //               })
  //             }
  //           }
  //           return null
  //         })
  // console.log(updatedListData,'updatedListData')
  //         setProject(updatedListData)
  //         return null
  //       }
  //        else {
  //         Object.entries(formDatas).map(([name, item]) => {
  //           let currentFormValue = item
  //           if (name.includes(data?.formName)) {
  //             if (name?.includes('award')) {
  //               let awardIndex = name?.split('_')[3]

  //               let newAwardName = newFormName + '_award_' + awardIndex
  //               form.setFieldsValue({
  //                 [newAwardName]: {
  //                   isDelete: true,
  //                   ...currentFormValue,
  //                 },
  //               })
  //             }
  //           }
  //           return null
  //         })
  //       }
  //       return null
  //     })
  //     console.log(updatedListData,'updatedListData')
  //     setProject(updatedListData)
  //   }

  if (isDelete) {
    let updatedList = projectUpdated?.filter(
      data => data?.formName !== deleteForm
    )
    form.setFieldsValue({
      [deleteForm]: { isDelete: true },
    })

    setProjectUpdated(updatedList)
    // return setProject(updatedList)
  }
  }

  const internshipHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = form.getFieldValue()
  
      const projects = {}
      const internships = {}
      for (const key in experienceKeys) {
        if (key.startsWith('project_')) {
          projects[key] = experienceKeys[key]
        } else if (key.startsWith('internship_')) {
          internships[key] = experienceKeys[key]
        }
      }
  
      const internshipKeys = Object.keys(internships)
      let lastValue = 0
      for (let i = internshipKeys.length - 1; i >= 0; i--) {
        const key1 = internshipKeys[i]
        const intValue = parseInt(key1.split('_')[1])
        if (!isNaN(intValue)) {
          lastValue = intValue
          break
        }
      }
  
      let arr = []
      let formName = 'internship_' + (lastValue + 1)
  
      if (isAdd) {
        arr.push({ component: ProjectForm, formName: formName })
        setInternship(intern => intern.concat(arr))
        setInternshipUpdated(intern => intern.concat(arr))
      }
      if (isDelete) {
        let updatedList = internshipUpdated?.filter(
          data => data?.formName !== deleteForm
        )
        form.setFieldsValue({
          [deleteForm]: { isDelete: true },
        })
        setInternshipUpdated(updatedList)
        // return setInternship(updatedList)
      }
      // if (isDelete) {
      //   form.setFieldValue([[deleteForm], 'isDelete'], true)
      //   if (form.getFieldValue([deleteForm, 'isDelete']) === true) {
      //     form.resetFields([deleteForm])
      //   }
  
      //   let formDatas = form.getFieldValue()
      //   let updatedListData = []
      //   internship.map((data, index) => {
      //     let newFormName = 'internship_' + index
      //     if (deleteForm !== newFormName) {
      //       Object.entries(formDatas).map(([name, item]) => {
      //         let currentFormValue = item
      //         if (name.includes(data?.formName)) {
      //           form.setFieldsValue({
      //             [name]: null,
      //             'skill_set': [],
      //           })
      //           if (name?.includes('award')) {
      //             let awardIndex = name?.split('_')[3]
  
      //             let newAwardName = newFormName + '_award_' + awardIndex
      //             form.setFieldsValue({
      //               [newAwardName]: {
      //                 ...currentFormValue,
      //               },
      //             })
      //           } else {
      //             form.setFieldsValue({
      //               [newFormName]: {
      //                 ...currentFormValue,
      //               },
      //             })
      //             updatedListData.push({
      //               component: ProjectForm,
      //               formName: newFormName,
      //             })
      //           }
      //         }
      //         return null
      //       })
  
      //       setInternship(updatedListData)
      //       return null
      //     } 
      //     else {
      //       Object.entries(formDatas).map(([name, item]) => {
      //         let currentFormValue = item
      //         if (name.includes(data?.formName)) {
      //           if (name?.includes('award')) {
      //             let awardIndex = name?.split('_')[3]
  
      //             let newAwardName = newFormName + '_award_' + awardIndex
      //             form.setFieldsValue({
      //               [newAwardName]: {
      //                 isDelete: true,
      //                 ...currentFormValue,
      //               },
      //             })
      //           }
      //         }
      //         return null
      //       })
      //     }
      //     return null
      //   })
  
      //   setInternship(updatedListData)
      // }
    }
  
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const submitHandler = async (preventNavigation = false) => {
    let project = []
    let internship = []
    const values = await form.getFieldValue()
    
    const errorList = []
    await form
      .validateFields()
      .then()
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    
    if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('project') &&
          !name.includes('award') &&
          !obj?.isDelete && 
          (obj !== undefined)
        ) {
          project.push({
            ...obj,
            awards: [],
          })
        } else if (
          name.includes('internship') &&
          !name.includes('award') &&
          !obj?.isDelete && 
          (obj !== undefined)
        ) {
          internship.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardInternData = []
      Object.entries(internship).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (!obj?.certificate?.size && !obj?.certificate?.url) {
            delete obj?.certificate
          }
          if (name.includes('internship_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardInternData.push(load)
          }
        })
      })

      for (let i = 0; i < internship.length; i++) {
        for (const [key, value] of Object.entries(awardInternData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              internship[i].awards.push(value1)
            }
          }
        }
      }

      let awardProjectData = []
      Object.entries(project).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (!obj?.certificate?.size && !obj?.certificate?.url) {
            delete obj?.certificate
          }
          if (name.includes('project_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardProjectData.push(load)
          }
        })
      })

      for (let i = 0; i < project.length; i++) {
        for (const [key, value] of Object.entries(awardProjectData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              project[i].awards.push(value1)
            }
          }
        }
      }

      if (
        (cvDetails?.projects && cvDetails?.projects?.length) ||
        (cvDetails?.internship && cvDetails?.internship?.length)
      ) {
        studentFormData.student.cvDetails = {
          ...cvDetails,
          projects: project,
          internships: internship,
        }
      }
      project = project.map(proj => ({
        ...proj,
        temp_id: proj?.id ? proj?.temp_id : (proj?.temp_id || `temp-${uuidv4()}`),
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }));
      internship = internship.map(proj => ({
        ...proj,
        temp_id: proj?.id ? proj?.temp_id : (proj?.temp_id || `temp-${uuidv4()}`),
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }));

      setSubmitLoading(true)
      let payload = {
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student,
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? studentFormData?.currentCourse
          : {},
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},

        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          projects: project,
          internships: internship,
        },
        checkForApproval: true,
        checkDeleteSection: ["projects", "internships"],
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      studentFormData?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })

      payload?.resume?.internships.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0 ||
          (!item?.certificate?.size && !item?.certificate?.url)
        ) {
          delete payload?.resume?.internships[index]?.certificate
        }
      })

      payload?.resume?.projects.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0 ||
          (!item?.certificate?.size && !item?.certificate?.url)
        ) {
          delete payload?.resume?.projects[index]?.certificate
        }
      })

      let response = await updateStudentData(payload)
      
      if (response?.success === true) {
        await getStudentData()
        SuccessMessage('Project and internship saved successfully!')
        setSubmitLoading(false)
        if (!preventNavigation) {
          setActiveTab('work')
        }
        setUpdated(true)
      } else {
        setSubmitLoading(false)
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const handleBackClick = async () => {
    // Save current form data before navigating back
    await form.validateFields()
      .then(async () => {
        await submitHandler(true) // Pass true to prevent forward navigation
        setActiveTab('education')
      })
      .catch(() => {
        // If validation fails, still navigate back without saving
        setActiveTab('education')
      })
  }

  const scrollToFirstError = errors => {
    const firstErrorField = errors?.[errors?.length - 1]
    if (firstErrorField) {
      const firstErrorField1 = firstErrorField.name.join('.')
      formRef.current.scrollToField(firstErrorField1)
    }
  }
  return (
    <Fragment>
      {!loading && !skillLoading ? (
        <>
          <Form
            scrollToFirstError
            onFinish={submitHandler && !updated}
            id={'projectForm'}
            form={form}
            layout="vertical"
            ref={formRef}
            onFinishFailed={({ errorFields }) => {
              scrollToFirstError(errorFields)
            }}
          >
            {!!project?.length &&
              project?.map((obj, index) => {
                const projectData = projectUpdated[index]
                return (
                  <obj.component
                    key={index + 'project'}
                    form={form}
                    onRemove={projectHandler}
                    formName={obj?.formName}
                    studentFormData={studentFormData}
                    setCorporateName={setCorporateName}
                    corporateName={corporateName}
                    setCorporateId={setCorporateId}
                    getCorporateList={getCorporateList}
                    corporateId={corporateId}
                    getListOfSkills={getListOfSkills}
                    skillLoading={skillLoading}
                    setSkillLoading={setSkillLoading}
                    SkillsAPI={SkillsAPI}
                    allSkills={allSkills}
                    getDesignationsList={getDesignationsList}
                    getFunctionsList={getFunctionsList}
                    getIndustryList={getIndustryList}
                    isCvTrue={isCvTrue}
                    searchAPI={searchAPI}
                    shown={shown}
                    pendingFields={projectData?._pendingFields}
                    hasPendingChanges={projectData?._hasPendingChanges}
                  />
                )
              })}
          </Form>
          <SubHeading1>Note:</SubHeading1>
          <SubHeading1>
            Please fill in all details in the section below to ensure exposure
            to maximum number of corporates
          </SubHeading1>
          <ButtonLocal onClick={() => projectHandler(true, false, null)}>
            <Control alignCenter gap="10px">
              <AdjustIcon>
                <AddIcon />
              </AdjustIcon>
              <Text>Add Project</Text>
            </Control>
          </ButtonLocal>
          <Form
            scrollToFirstError
            onFinish={submitHandler && !updated}
            id={'projectForm'}
            form={form}
            layout="vertical"
            ref={formRef}
            onFinishFailed={({ errorFields }) => {
              scrollToFirstError(errorFields)
            }}
          >
            {!!internship?.length &&
              internship?.map((obj, index) => {
                const internshipData = internshipUpdated[index]
                return (
                  <obj.component
                    key={index + 'internship'}
                    form={form}
                    onRemove={internshipHandler}
                    formName={obj?.formName}
                    studentFormData={studentFormData}
                    setCorporateName={setCorporateName}
                    corporateName={corporateName}
                    setCorporateId={setCorporateId}
                    corporateId={corporateId}
                    getListOfSkills={getListOfSkills}
                    skillLoading={skillLoading}
                    setSkillLoading={setSkillLoading}
                    getCorporateList={getCorporateList}
                    SkillsAPI={SkillsAPI}
                    allSkills={allSkills}
                    getDesignationsList={getDesignationsList}
                    getFunctionsList={getFunctionsList}
                    getIndustryList={getIndustryList}
                    isCvTrue={isCvTrue}
                    searchAPI={searchAPI}
                    pendingFields={internshipData?._pendingFields}
                    hasPendingChanges={internshipData?._hasPendingChanges}
                  />
                )
              })}
          </Form>
          <SubHeading1>Note:</SubHeading1>
          <SubHeading1>
            Please fill in all details in the section below to ensure exposure
            to maximum number of corporates
          </SubHeading1>
          <ButtonLocal onClick={() => internshipHandler(true, false)}>
            <Control alignCenter gap="10px">
              <AdjustIcon>
                <AddIcon />
              </AdjustIcon>
              <Text>Add internship</Text>
            </Control>
          </ButtonLocal>

          <Control width="100%" flexEnd gap="15px" top="35px">
            <Button.Secondary
              text="Back"
              onClick={handleBackClick}
            />
            <Button.Primary
              text="Save & Continue"
              form={'projectForm'}
              htmlType={'submit'}
              onClick={() => submitHandler()}
              disable={submitLoading}
            />
          </Control>
        </>
      ) : (
        <SpinWrapper center>
          <Spin />
        </SpinWrapper>
      )}
    </Fragment>
  )
}

export default ProjectInternship
